const ENV = import.meta.env.VITE_ENV || 'DEV';

export const Environment = {
  isDev: ENV === 'DEV',
  isProd: ENV === 'PROD',
  projectId: ENV === 'PROD' ? 'assetflow-backend-2024' : 'assetflow-dev-f6fa5',
  label: ENV === 'PROD' ? 'PROD' : 'DEV',
} as const;
